import Vue from "vue";
export default new Vue({});

//事件名setScrollTop
//设置当前dom滚动高度为0 ，参数为0

//事件名为handleViewContainerScroll
//blogContent的scroll事件 参数为dom

//事件名为mainScroll
//blogDetail的scroll事件 参数为dom

//事件名为handleAnchor
//blogLIst top之后选中状态处理 参数为''
